import React from "react";
import { formatDateMDDYYYY } from "../utils/Date.util";

const BlogStyle4 = ({ post }) => {
    return (
        <div className="blog-style4">
            <div className="blog-img">
                <img
                    src={`${process.env.REACT_APP_REDLINES_IMAGE_STORAGE}/${post.featured_image}`}
                    alt={post.title}
                    style={{ height: "100%" }}
                />
            </div>
            <div className="blog-content">
                <a
                    data-theme-color="#59C2D6"
                    href={`/category/${post.categories[0].name}`}
                    className="category"
                >
                    {post.categories[0].name}
                </a>
                <h3 className="box-title-22">
                    <a className="hover-line" href={`/post/${post.id}`}>
                        {post.title}
                    </a>
                </h3>
                <div className="blog-meta">
                    <p>
                        <i className="far fa-user"></i>
                        By - {post.author_id}
                    </p>
                    <p>
                        <i className="fal fa-calendar-days"></i>
                        {formatDateMDDYYYY(post.created_at)}
                    </p>
                </div>
                <a href={`/post/${post.id}`} className="th-btn style2">
                    Read More
                </a>
            </div>
        </div>
    );
};

export default BlogStyle4;
